@let tariffStoreTariff = tariffStore.tariff$();

<div class="flex gap-2 md:gap-6 items-center">
    <label
        class="tarif-button-custom-styling w-28 h-28 md:w-80 md:h-auto p-4 md:p-3
    flex flex-col-reverse md:flex-row md:gap-0 justify-between items-center
    disabled:border-grey disabled:text-grey md:hover:bg-grey md:border-2
    md:solid md:border-secondary rounded-xl transition duration-200 ease-in
    cursor-pointer"
        [class.is-active]="tariffStoreTariff === 'single'"
        [ngClass]="getOuterClasses()">
        <input
            type="radio"
            name="tariff"
            value="single"
            class="absolute opacity-0 w-0 h-0 peer"
            [checked]="tariffStoreTariff === 'single'"
            (change)="click('single')"
            aria-label="Select Single Tariff" />
        <mat-icon
            class="!h-10 !w-auto md:!w-4/12 single"
            svgIcon="single"
            aria-hidden="false"
            aria-label="Single Tarif icon" />
        <span class="md:hidden text-[16px] text-center whitespace-nowrap">Mich</span>
        <span class="hidden md:inline-block w-7/12 text-[24px] text-left whitespace-nowrap">Mich</span>
    </label>

    <div class="relative block w-[60px] h-6 md:h-7 bg-white border-secondary border rounded-full cursor-pointer has-[:checked]:bg-primary">
        <input [checked]="tariffStoreTariff === 'family'"
               (click)="toggle()"
               class="not-sr-only opacity-0 w-[60px] h-6 md:h-7 peer cursor-pointer"
               type="checkbox"
               tabindex="-1"
               aria-label="Tariff Toggle">
        <span
            class="absolute block rounded-full bg-primary w-4 h-4 md:w-5 md:h-5 top-1/2 mx-1 -translate-y-1/2 transition-transform peer-checked:translate-x-[34px] md:peer-checked:translate-x-[30px] peer-checked:bg-white pointer-events-none"></span>
    </div>


    <label
        class="tarif-button-custom-styling w-28 h-28 md:w-80 md:h-auto p-4 md:p-3
    flex flex-col-reverse md:flex-row
    md:gap-0 justify-between items-center
    disabled:border-grey disabled:text-grey
    md:hover:bg-grey
    md:border-2 md:solid md:border-secondary rounded-xl transition duration-200 ease-in
    cursor-pointer"
        [class.is-active]="tariffStoreTariff === 'family'"
        [ngClass]="getOuterClasses()">
        <input
            type="radio"
            name="tariff"
            value="family"
            class="absolute opacity-0 w-0 h-0 peer"
            [checked]="tariffStoreTariff === 'family'"
            (change)="click('family')"
            aria-label="Select Family Tariff" />
        <mat-icon
            class="!h-10 !w-16 md:!w-4/12 family"
            svgIcon="family"
            aria-hidden="false"
            aria-label="Family Tarif icon" />
        <span class="md:hidden text-[16px] text-center whitespace-nowrap">Familie</span>
        <span class="hidden md:inline-block w-7/12 text-[24px] text-left whitespace-nowrap">Meine Familie</span>
    </label>

</div>
